import { render, staticRenderFns } from "./interactiveMessage.vue?vue&type=template&id=23cd82b0&scoped=true&"
import script from "./interactiveMessage.vue?vue&type=script&setup=true&lang=js&"
export * from "./interactiveMessage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./interactiveMessage.vue?vue&type=style&index=0&id=23cd82b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cd82b0",
  null
  
)

export default component.exports